export const FavoritesLink = '/favourite-products';
